const ITEMS = [
  "Rest",
  "Renew",
  "Write",
  "Connect",
  "Hospice",
  "Healthcare",
  "Military",
  "Public Safety",
  "Corporate",
  "Community Chaplaincy",
  "All Faith Traditions",
];

export default function Marquee() {
  return (
    <section
      aria-hidden="true"
      data-testid="editorial-marquee"
      className="marquee grain relative overflow-hidden border-y border-gold/25 bg-navy-abyss py-4"
    >
      <div className="marquee-track flex w-max whitespace-nowrap">
        {[0, 1].map((copy) => (
          <div key={copy} aria-hidden={copy === 1} className="flex">
            {ITEMS.map((item, i) => (
              <span
                key={i}
                className="mx-7 flex items-center gap-7 font-mono text-[11px] uppercase tracking-[0.3em] text-gold-light/90"
              >
                {item}
                <span className="text-gold/50">·</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
